import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,
  Radio,
  Label,
} from 'semantic-ui-react';
import _ from 'lodash';
import { userConstants } from '../../constants/user.constants';
import { holidayActions } from '../../actions/holiday.actions';
import { holidayScopeOptions } from '../../constants/holiday.constants';
import brazilLocations from '../../data/brazil-locations.json';

const stateOptions = brazilLocations.states.map(s => ({ key: s.uf, value: s.nome, text: s.nome }));

function cityOptionsFor(stateName) {
  const cities = brazilLocations.citiesByState[stateName] || [];
  return cities.map(c => ({ key: c, value: c, text: c }));
}

class HolidayFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      holiday: {
        name: '',
        scope: 0,
        day: 1,
        month: 1,
        annual: true,
        year: '',
        country: 'Brasil',
        state: '',
        city: '',
        enabled: true,
      },
      errors: {},
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    if (match.params.id) {
      dispatch(holidayActions.get(match.params.id))
        .then(() => {
          const holiday = _.mapKeys(this.props.holiday, function (v, k) { return k.charAt(0).toLowerCase() + k.slice(1); });
          this.setState({ holiday });
        });
    }
  }

  handleChange(field, data) {
    const { holiday } = this.state;
    holiday[field] = data;
    if (field === 'state' && holiday.city && !(brazilLocations.citiesByState[data] || []).includes(holiday.city)) {
      holiday.city = '';
    }
    this.setState({ holiday });
  }

  validate() {
    const { holiday } = this.state;

    let errors = {};
    let valid = true;

    if (!holiday.name || holiday.name.length === 0) {
      errors.name = "Preencha o nome";
      valid = false;
    }

    const day = parseInt(holiday.day, 10);
    if (isNaN(day) || day < 1 || day > 31) {
      errors.day = "Informe um dia entre 1 e 31";
      valid = false;
    }

    const month = parseInt(holiday.month, 10);
    if (isNaN(month) || month < 1 || month > 12) {
      errors.month = "Informe um mês entre 1 e 12";
      valid = false;
    }

    if (!holiday.annual && !holiday.year) {
      errors.year = "Informe o ano para feriados não anuais";
      valid = false;
    }

    if (holiday.scope === 1 && (!holiday.state || holiday.state.length === 0)) {
      errors.state = "Estado é obrigatório para feriados estaduais";
      valid = false;
    }

    if (holiday.scope === 2) {
      if (!holiday.state || holiday.state.length === 0) {
        errors.state = "Estado é obrigatório para feriados municipais";
        valid = false;
      }
      if (!holiday.city || holiday.city.length === 0) {
        errors.city = "Município é obrigatório para feriados municipais";
        valid = false;
      }
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { holiday } = this.state;
    const payload = {
      ...holiday,
      year: holiday.annual ? null : parseInt(holiday.year, 10),
    };

    if (holiday.id) {
      dispatch(holidayActions.update(holiday.id, payload));
    } else {
      dispatch(holidayActions.create(payload));
    }
  }

  render() {
    const { holiday, errors } = this.state;
    const { me, loading } = this.props;

    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    return (
      <Fragment>
        <h1>Feriado</h1>
        <Form loading={loading} onSubmit={() => this.handleSubmit()}>
          <Form.Input required error={errors.name} label='Nome' value={holiday.name} name='name' type='text' onChange={(e, data) => this.handleChange("name", data.value)} placeholder='Ex: Natal' />
          {errors.name && <Label color='red'>{errors.name}</Label>}

          <Form.Select required label='Abrangência' value={holiday.scope} name='scope' onChange={(e, data) => this.handleChange("scope", data.value)} options={holidayScopeOptions} />

          <Form.Group widths='equal'>
            <Form.Input required error={errors.day} label='Dia (1-31)' value={holiday.day} name='day' type='number' min={1} max={31} onChange={(e, data) => this.handleChange("day", data.value)} />
            <Form.Input required error={errors.month} label='Mês (1-12)' value={holiday.month} name='month' type='number' min={1} max={12} onChange={(e, data) => this.handleChange("month", data.value)} />
          </Form.Group>
          {(errors.day || errors.month) && <Label color='red'>{errors.day || errors.month}</Label>}

          <Form.Input>
            <Radio toggle checked={holiday.annual} label='Repete todo ano' onChange={(e, data) => this.handleChange("annual", data.checked)} />
          </Form.Input>

          {!holiday.annual &&
            <Fragment>
              <Form.Input required error={errors.year} label='Ano' value={holiday.year} name='year' type='number' onChange={(e, data) => this.handleChange("year", data.value)} placeholder='Ex: 2026' />
              {errors.year && <Label color='red'>{errors.year}</Label>}
            </Fragment>}

          <Form.Input label='País' value={holiday.country} name='country' type='text' onChange={(e, data) => this.handleChange("country", data.value)} placeholder='Deixe em branco para todos os países' />

          {(holiday.scope === 1 || holiday.scope === 2) &&
            <Fragment>
              <Form.Select required search error={errors.state} label='Estado' value={holiday.state} name='state' placeholder='Selecione o estado' onChange={(e, data) => this.handleChange("state", data.value)} options={stateOptions} />
              {errors.state && <Label color='red'>{errors.state}</Label>}
            </Fragment>}

          {holiday.scope === 2 &&
            <Fragment>
              <Form.Select required search error={errors.city} label='Município' value={holiday.city} name='city' placeholder={holiday.state ? 'Selecione o município' : 'Selecione o estado primeiro'} disabled={!holiday.state} onChange={(e, data) => this.handleChange("city", data.value)} options={cityOptionsFor(holiday.state)} />
              {errors.city && <Label color='red'>{errors.city}</Label>}
            </Fragment>}

          <Form.Input>
            <Radio toggle checked={holiday.enabled} label='Habilitado' onChange={(e, data) => this.handleChange("enabled", data.checked)} />
          </Form.Input>

          <Button primary type='submit'>{holiday.id ? 'Alterar' : 'Criar'} Feriado</Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, holiday } = state;
  let props = {
    me: users.me || null,
    loading: holiday.loading,
  };

  if (holiday && holiday.holiday) {
    props.holiday = holiday.holiday;
  }

  return props;
}

const connectedHolidayFormScreen = connect(mapStateToProps)(HolidayFormScreen);
export { connectedHolidayFormScreen as HolidayFormScreen };
